module.exports = __webpack_public_path__ + "static/media/1_A1_20.b8069fe9.png";